import { Button } from "primereact/button";
import { useMutation } from "react-relay";
import { toast } from "react-toastify";
import { useTranslation } from "@i18n/hooks";
import { RESET_STAGING_USER_PROGRESS_MUTATION } from "./reset-staging-user-progress-button.graphql";

export const ResetStagingUserProgressButton = () => {
	const { t } = useTranslation("common");
	const [resetStagingUserProgress, isResettingStagingUserProgress] = useMutation(
		RESET_STAGING_USER_PROGRESS_MUTATION,
	);

	const handleOnClick = () => {
		resetStagingUserProgress({
			variables: {},
			onCompleted: () => {
				toast.success(t("staging.resetUserProgressSuccess"));
			},
		});
	};

	return (
		<Button
			className={"mb-2"}
			label={t("staging.resetUserProgress")}
			disabled={isResettingStagingUserProgress}
			onClick={handleOnClick}
		/>
	);
};
